module.exports = __webpack_public_path__ + "img/qq_message.8f20bfea.png";